// extracted by mini-css-extract-plugin
export default {"title":"TestimonialSlider_title__2755g","slider":"TestimonialSlider_slider__2lCqS"};